import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { ReceiptViewerDialogComponent } from './receipt-viewer-dialog.component';

export interface ReceiptViewerDialogInput {
  receiptUrl: string;
  period: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReceiptViewerDialogService extends AbstractDialogService<
  ReceiptViewerDialogInput,
  void,
  typeof ReceiptViewerDialogComponent
> {
  readonly id = 'receipt-viewer-dialog';
  protected readonly component = ReceiptViewerDialogComponent;

  protected override readonly options: DialogOptions = {
    cssClass: 'fullscreen',
    showBackdrop: true,
    handle: false,
  };

  override openDialog(config: { input: ReceiptViewerDialogInput; options?: DialogOptions }) {
    return super.openDialog({
      ...config,
      options: {
        ...this.options,
        ...config.options,
        componentProps: {
          receiptUrl: config.input.receiptUrl,
          period: config.input.period,
        },
      },
    });
  }
}
